// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2dFFo","footer":"ModalUpdate_footer__2eyNz"};